module.exports = __webpack_public_path__ + "img/253.thank_you_bought.1efad964.svg";